import Moment from 'moment';
import { Area, Floor, Space } from '../../components/Map/SetFloorsModal/FloorItem';
import { AssetInstance, UserGroup, UserInstance } from '../../constants/Types';
import { getUserFullName } from '../../constants/Utils';

// eslint-disable-next-line no-shadow
export enum TicketPriorityTitle {
  // eslint-disable-next-line no-unused-vars
  CRITICAL = 'critical', HIGH = 'high', MODERATE = 'moderate', LOW = 'low', OTHER = 'other',
}

export const parseSlaTime = (hours: number) => {
  if (hours <= 0) return '0 hours';
  Moment.updateLocale('en', {
    relativeTime: {
      s: '%d seconds',
      m: '%d minute',
      h: '%d hour',
      hh: '%d hours',
      d: '%d day',
      dd: '%d days',
    },
  });
  if (hours < 24) return Moment.duration(hours, 'hours').humanize();
  if (hours % 24 === 0) return hours / 24 === 1 ? '1 day' : `${hours / 24} days`;
  return `${hours} hours`;
};

export const generateAvatarColor = (length: number) => `#${Math.floor((1 / length) * 16777215)
  .toString(16).padStart(6, '0')}`;

export const assigneeName = (clientIdEmail: string, users: UserInstance[]) => {
  let assignee = clientIdEmail;
  users?.forEach((user: UserInstance) => {
    if (user.id === clientIdEmail) assignee = getUserFullName(user);
  });
  return assignee;
};

export const assetName = (assetId: string, assets: AssetInstance[]) => (assetId ? assets
  ?.filter((asset: AssetInstance) => asset?.id === assetId)[0]?.name ?? assetId : null);

export const getStartedOnDate = (startedon: string) => Moment(new Date(startedon)).format('llll');

export const userGroupName = (userGroupId: string, userGroups: UserGroup[]) => userGroups
  ?.filter((userGroup) => userGroup?.UserGroupId === userGroupId)[0]?.Name ?? userGroupId;

export const templateName = (templateId: string, templates: any[]) => templates
  ?.filter((template) => template?.id === templateId)[0]?.name ?? templateId;

export const locationName = (locationId: string, locations: object | null) => {
  let location: string = locationId;
  Object.values(locations ?? {}).forEach((floor: Floor | null) => {
    if (floor) {
      if (floor.LocationId === locationId) location = floor.Name;
      else {
        Object.values(floor.areas ?? {}).forEach((area: Area | null) => {
          if (area) {
            if (area.LocationId === locationId) location = area.Name;
            else {
              Object.values(area.spaces ?? {}).forEach((space: Space) => {
                if (space && space.LocationId === locationId) location = space.Name;
              });
            }
          }
        });
      }
    }
  });
  return location;
};
